import { ProgressBar, Card, InlineStack, BlockStack, Text, Badge, Icon, Tooltip, Divider } from '@shopify/polaris';
import React from 'react'
import { DIProps } from '../../../../Core';
// import { processCodeMapping } from '../../Overview/Componants/Activities';
import { useTranslation } from 'react-i18next';
import { ClockIcon } from '../../../../../src/Asests/svgIcon/icon';
import Shopify from "../../../../Asests/Images/shopify.png"
import Amazon from "../../../../Asests/Images/amazon.png"
import { processCodeMapping } from './Activity';
interface Props extends DIProps {
    queudTask: any
}



const RenderQueueTasks = (Props: Props) => {
    const { queudTask } = Props
    const { t } = useTranslation();

    return <>

        {queudTask.map((m: any, k: number) => {
            return (
                <React.Fragment key={k}>
                    <BlockStack gap='200'>
                        <InlineStack align='space-between'>
                            <InlineStack gap="200" align='start'>
                                <Text variant="headingMd" as="h6">{m?.additional_data?.process_label ?? processCodeMapping(t)[m?.process_code] ?? "App Process"}</Text>
                                {m?.['process_initiation'] ? <Badge>{m?.process_initiation.charAt(0).toUpperCase() + m?.process_initiation.slice(1)}</Badge> : null}
                            </InlineStack>
                            <img alt='shopify' src={Props?.redux?.current?.target?.['_id'] == m?.shop_id ? Amazon : Shopify} />
                        </InlineStack>
                        <InlineStack blockAlign='center' align="space-between" gap="200">
                            <InlineStack gap="200" blockAlign='start'>
                                <div><Icon source={ClockIcon}></Icon></div>
                                <BlockStack inlineAlign='stretch' align='space-evenly' gap="100">
                                    <Text as='p'>{t(m?.message)}</Text>
                                    <Text variant="bodySm" as="p" tone="subdued">{m['created_at'] != undefined && <Text as='span' tone='subdued'>{`started ${new Date(m.created_at).toUTCString()}`}</Text>}</Text>
                                </BlockStack>
                            </InlineStack>
                            <div style={{ minWidth: 250 }}>
                                <Tooltip content={`${m?.progress || 0}% Done`} dismissOnMouseOut>
                                    <ProgressBar animated progress={m?.progress || 0} tone="primary" size="small" />
                                </Tooltip>
                            </div>
                        </InlineStack>
                        {queudTask.length - 1 !== k && (
                            <Divider borderColor="border-secondary" />
                        )}
                    </BlockStack>
                </React.Fragment>
                // <Card roundedAbove='sm' key={k}>
                //     <InlineStack gap="400" align='space-between' blockAlign="center">
                //         <BlockStack gap="100">
                //             <Text as='p'>{t(m["message"])}</Text>
                //             <Text as='p'>{m['created_at'] != undefined && <Text as="span" tone='subdued'>{new Date(m.created_at).toUTCString()}</Text>}</Text>
                //         </BlockStack>
                //         <div style={{ minWidth: 165 }}>
                //             <ProgressBar
                //                 progress={m['progress'] ?? 0}
                //                 tone="primary"
                //                 size="small"
                //             />
                //         </div >
                //     </InlineStack>
                // </Card>
            );
        })}
    </>;
}

export default RenderQueueTasks